export function cleanObject<T extends Record<string, unknown>>(
  obj: T,
  valueToClean: unknown[] | ((val: unknown) => boolean) = [null]
): T {
  if (!isObject(obj)) {
    throw new Error('"obj" argument must be of type "object"');
  }

  const cleanObj: T = {} as T;
  let filter: (val: unknown) => boolean;

  if (Array.isArray(valueToClean)) {
    filter = (val: unknown) => valueToClean.includes(val);
  } else if (typeof valueToClean === 'function') {
    filter = valueToClean;
  } else {
    filter = (val: unknown) => val === valueToClean;
  }

  // Iterate over the object properties
  for (const key in obj) {
    const objValue = obj[key];

    if (isObject(objValue)) {
      cleanObj[key] = cleanObject(objValue, filter) as T[Extract<
        keyof T,
        string
      >];
    } else if (!filter(objValue)) {
      cleanObj[key] = objValue;
    }
  }

  return cleanObj;
}

const isObject = (val: unknown): val is Record<string, unknown> => {
  return val != null && typeof val === 'object' && !Array.isArray(val);
};
